import { lighten, shade } from "polished";
import styled, { css } from "styled-components";
import { colors } from "../../../../../theme/theme";


interface CloseInvoiceBtnProps {
    isDisabled: boolean;
}


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;



    main { 
        .customRows { 
            background-color: #F6F7FB ;
            color: ${colors.greyscale.darker_grey};
        }

        span { 
        font-size: 14px;
        color: ${colors.greyscale.darker_grey};
        }

    }
    
`;

export const CloseInvoiceBtn = styled.button<CloseInvoiceBtnProps>`
        border-radius: 4px;
        padding: 8px 16px;
        margin-left: 10px;
        background: ${colors.mainColors.verde_dstore};
        color: ${colors.greyscale.white};
        border: 0;
        ${props =>
        props.isDisabled &&
        css`
            background: ${lighten(0.2, colors.mainColors.verde_dstore)};
            ` }

        
            &:hover {

                ${props =>
                    !props.isDisabled &&
                     css`
                        background: ${shade(0.2, colors.mainColors.verde_dstore)};`
                }
            }

        @media only screen and (max-width: 1100px) { 
            margin-left: 0px;
            margin-top: 10px;
        }
    
`;

export const BillingSelect = styled.div`
    /* max-width: 200px; */
    display: flex;
    align-items: center;

    select  { 
        color: ${colors.mainColors.blueberry};
        border: 1px solid ${colors.mainColors.blueberry};
    }

    span { 
        min-width: 130px;
    }

    @media only screen and (max-width: 1100px) { 
        flex-direction: column;
    }
    
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.greyscale.light_grey};
    margin-bottom: 24px;
    padding-bottom: 10px;

    h1 { 
        color: ${colors.greyscale.darker_grey};
        font-size: 24px;
        margin-bottom: 0px;
        font-weight: 700;
        margin-right: 1rem;
    }

    span { 
        font-size: 14px;
        color: ${colors.greyscale.darker_grey};
    }


    @media only screen and (max-width: 1100px) { 
       flex-direction: column;
    }

`;

export const HeaderSeparation = styled.div` 
    display: flex; 
    justify-content: space-between;
    min-width: 35%;

    @media only screen and (max-width: 1100px) { 
       /* flex-direction: column; */
       margin-top: 10px;
       align-items: flex-end !important;
    }

    @media only screen and (max-width: 516px) { 
       flex-direction: row;
       margin-top: 10px;
       align-items: flex-end !important;

       #periodDesc { 
           visibility: hidden;
       }
    }


`;


export const FirstGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    grid-gap: 20px;
    flex: 1;
    margin-bottom: 15px;
`;


export const Card = styled.div`
    display: flex;
    flex-direction: column;
    padding: 50px;
    box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
    color: ${colors.greyscale.black};
    text-align: center;
`;



export const CardTitle = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;

    h2 { 
        font-weight: 700;
    }
    
`;

